module.exports = __webpack_public_path__ + "static/media/home-banner@2x.7904e87c.jpg";